export default __webpack_public_path__ + "static/media/Mezcal.472df4f6.jpg";